// ** Third Party Imports
import styled from 'styled-components'
import * as Accordion from '@radix-ui/react-accordion'

export const AccordionRoot = styled(Accordion.Root)<{ $isLoading?: boolean }>`
	${({ $isLoading }) => $isLoading && `opacity: 0.3; pointer-events: none;`}
`
